import React from 'react';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function CountryTags (props) {
  var displayCountryYears = (years) => {
    var display = ''
    var i = 0
    var displayMore = <span>{props.country}<br/>
                       {years.join(', ')}
                      </span>
    while( years[i] && i < 5){
      display = display ===''? years[i]: display + ', ' + years[i]
      i ++
    }
    if(years[6]){
      return <span>{display+' '}
              <FontAwesomeIcon onMouseEnter={() => props.onHoverDisplayYears(displayMore)}
                               onMouseLeave={() => props.onLeaveDisplayYears()}
                              icon="ellipsis-h"/>

            </span>
    }
    return <span>{display}</span>
  }
    return (
        <div className="country-tag">
          <div>
            <div>
              {props.country.slice(0, 22)}
            </div>
            <div style={{color: '#969696', fontSize: '10px'}}>
              {displayCountryYears(props.countryAvailableYears[props.country])}
            </div>
          </div>
          <span style={{cursor: "pointer"}} onClick={ () => props.onDeleteCountry(props.country)}>
            x
          </span>
        </div>
      );
  }

  function mapStateToProps(state){
    return {
      countries: state.countries,
      countryAvailableYears: state.countryAvailableYears
    }
  };

  function mapDispatchToProps(dispatch){
    return {
      onDeleteCountry: (country) => dispatch({ type: 'DELETECOUNTRY', value: country }),
    //  addNotes: () => dispatch({ type: 'ADDNOTES' }),
    //  addPhotos: (photos) => dispatch({ type: 'ADDPHOTOS', value: photos})
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(CountryTags);


//export default CountryTags;



// WEBPACK FOOTER //
// ./src/components/CountryTags.js